import scrollService from '../core/ScrollService.js';
const initFormPopup = () => {
    const articlePopup = document.querySelector('.article-popup');
    const formPopup = document.querySelector('.form-popup');
    if (!formPopup || !articlePopup) return;

    // Gestion fermeture article popup
    const closeBtn = articlePopup.querySelector('.popup-close');
    if (closeBtn) {
        closeBtn.addEventListener('click', () => {
            articlePopup.classList.remove('active');
            const handleTransitionEnd = () => {
                articlePopup.style.display = 'none';
                articlePopup.removeEventListener('transitionend', handleTransitionEnd);
                scrollService.start();
            };
            articlePopup.addEventListener('transitionend', handleTransitionEnd);
        });
    }

    // Ouvre la popup formulaire au clic sur le CTA de la première popup
    const popupCta = articlePopup.querySelector('.popup-cta');
    if (popupCta) {
        popupCta.addEventListener('click', (e) => {
            e.preventDefault();
            e.stopPropagation();
            formPopup.classList.add('active');
            scrollService.stop();
            return false;
        });
    }

    // Gestion de la fermeture de la popup formulaire
    const formPopupClose = formPopup.querySelector('.popup-close');
    if (formPopupClose) {
        formPopupClose.addEventListener('click', () => {
            const hasConfirmation = formPopup.querySelector('.gform_confirmation_wrapper');
            formPopup.classList.remove('active');
            const handleTransitionEnd = () => {
                formPopup.removeEventListener('transitionend', handleTransitionEnd);
                setTimeout(() => {
                    scrollService.start();
                    if (hasConfirmation) {
                        articlePopup.style.display = 'none';
                        articlePopup.classList.remove('active');
                    }
                }, 100);
            };
            formPopup.addEventListener('transitionend', handleTransitionEnd);
        });
    }
};

export { initFormPopup };
